import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// Context
import ApproachContext from '../../../../../context/ApproachContext';

// PropTypes
import { companyPropTypes } from '../../../../../proptypes/companyProptypes';

// Icons
import { StarEmpty } from '../../../../icons';

// Styles
import styles from '../jobBulletpoints.module.scss';

const JobRatings = ({ company, textColor }) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  return (
    <>
      {/* KUNUNU RATING */}
      {company.kununu_rating && Number(company.kununu_rating) >= 4 && (
        <div className={styles.container}>
          <span className={styles.content}>
            <span className={styles.iconWrapper}>
              <StarEmpty fill={textColor} className={styles.icon} />
            </span>
            <span className={styles.text} data-testid="kununu-rating">
              {t(`description_page.main_section.on_kununu.${approach}`, {
                rating: company.kununu_rating,
              })}
            </span>
          </span>
        </div>
      )}

      {/* GLASSDOOR RAITING */}
      {company.glassdoor_rating && Number(company.glassdoor_rating) >= 4 && (
        <div className={styles.container}>
          <span className={styles.content}>
            <span className={styles.iconWrapper}>
              <StarEmpty fill={textColor} className={styles.icon} />
            </span>
            <span className={styles.text} data-testid="glassdoor-rating">
              {t(`description_page.main_section.on_glassdoor.${approach}`, {
                rating: company.glassdoor_rating,
              })}
            </span>
          </span>
        </div>
      )}
    </>
  );
};

JobRatings.propTypes = {
  company: PropTypes.shape(companyPropTypes).isRequired,
  textColor: PropTypes.string.isRequired,
};

export default JobRatings;
